import React from 'react';
import { sweetalert } from '../../App';
import { isBlank, isOnlyWhitespace } from '../../util/ValidationUtil';
import { buildRow } from '../../util/FormatUtil';

interface KitProductionModalState {
  kitID: string;
  returnLabel: string;
}
interface KitProductionModalProps {
  kitInventory?;
  onSubmit?;
}
export class KitProductionModal extends React.Component<KitProductionModalProps, KitProductionModalState> {
  public static ID = 'kitproduction';
  constructor(props) {
    super(props);
    this.state = {
      kitID: null,
      returnLabel: null,
    } as KitProductionModalState;
  }

  componentDidMount() {
    const modalEl = document.getElementById(KitProductionModal.ID);
    if (modalEl) {
      $(modalEl).on('hidden.bs.modal', () => {
        this.setState({ kitID: null, returnLabel: null });
      });
    }
  }

  render() {
    // console.log('KitProductionModal render STATE', this.state);
    // console.log('KitProductionModal render PROPS', this.props);
    return (
      <div
        className="modal fade form_modal"
        id={KitProductionModal.ID}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="result_modal_label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="result_modal-label">
                  Kit Production
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow(
                  'Kit ID',
                  <input
                    className={'form-control'}
                    id="KitID"
                    maxLength={50}
                    autoComplete={'off'}
                    type={'search'}
                    name={'KitID'}
                    aria-label="KitID"
                    onChange={(e) => {
                      this.setState({ kitID: e.target.value });
                    }}
                    value={this.state.kitID || ''}
                  />
                )}
                {buildRow(
                  'Return Shipping Label',
                  <input
                    className={'form-control'}
                    id="ReturnShippingLabelNumber"
                    maxLength={50}
                    autoComplete={'off'}
                    type={'search'}
                    name={'Return Shipping Label'}
                    aria-label="Return Shipping Label"
                    onChange={(e) => {
                      this.setState({ returnLabel: e.target.value });
                    }}
                    value={this.state.returnLabel || ''}
                  />
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    if (isBlank(this.state.kitID) || isOnlyWhitespace(this.state.kitID)) {
                      return sweetalert.fire('', 'Kit ID cannot be empty.', 'error');
                    }
                    if (isBlank(this.state.returnLabel) || isOnlyWhitespace(this.state.returnLabel)) {
                      return sweetalert.fire('', 'Return Shipping Label cannot be empty.', 'error');
                    }
                    //@ts-ignore
                    let existingKit = this.props.kitInventory.find((k) => k.KitID === this.state.kitID);
                    if (existingKit) {
                      //if kit exists, ask user if they want to update it
                      return sweetalert
                        .fire({
                          title: 'A Kit record with this ID already exists',
                          text: 'Do you want to update this existing kit?',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonText: 'Yes, update it',
                          cancelButtonText: 'Cancel',
                        })
                        .then((result) => {
                          if (result.isConfirmed) {
                            this.props.onSubmit({
                              ID: existingKit.ID,
                              kitID: this.state.kitID,
                              ReturnShippingLabelNumber: this.state.returnLabel,
                            });
                          }
                        });
                    } else {
                      this.props.onSubmit({
                        ID: null,
                        kitID: this.state.kitID,
                        ReturnShippingLabelNumber: this.state.returnLabel,
                      });
                    }
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
